import { auth } from 'Utilities/config'

export const loginUser = async (email, pass) => {
    try {
        // const userCredentials = await auth.signInWithEmailAndPassword(email, pass);
        await auth.signInWithEmailAndPassword(email, pass);
        const result = {
            state: true,
            code: 'auth/login-successfully'
        }
        console.log(result);
        return result
    } catch(error) {
        const result = {
            state: false,
            code: error.code
        }
        console.log(result);
        return result;
    }
}

export const loggedInUser = () => {
    try {
        const user = auth.currentUser;
        if (user !== null) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        return error
    }
}

export const logoutUser = async () => {
    try {
        await auth.signOut();
        console.log('Sesión cerrada');
    } catch (error) {
        console.log(error);
    }
}
